import { render, staticRenderFns } from "./RoomMyChat.vue?vue&type=template&id=848f8e1c&"
import script from "./RoomMyChat.vue?vue&type=script&lang=js&"
export * from "./RoomMyChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848f8e1c')) {
      api.createRecord('848f8e1c', component.options)
    } else {
      api.reload('848f8e1c', component.options)
    }
    module.hot.accept("./RoomMyChat.vue?vue&type=template&id=848f8e1c&", function () {
      api.rerender('848f8e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Chat/RoomMyChat.vue"
export default component.exports